<template>
  <div class="fts-signature">
    <fts-display 
      :formData="formData" 
      :item="item" 
      :vectorId="vectorId"
      v-if="isSigned" />

    <vueSignature 
      class="signature-wrapper"
      ref="signature"
      :sigOption="option"
      :w="'300px'"
      :h="'150px'"
      :disabled="disabled"
      :defaultUrl="dataUrl"
      :key="uid" 
      v-else-if="uid" />

    <div class="signature-action">
      <div class="signature-action-btn danger-btn" @click="clear">
        <font-awesome-icon :icon="['fas', 'times']" />
        <div class="action-btn-label">Clear</div>
      </div>
      <div class="signature-action-btn primary-btn" @click="save" v-if="!isSigned">
        <font-awesome-icon :icon="['fas', 'check']" />
        <div class="action-btn-label">Signed</div>
      </div>
    </div>
    
    <fts-file-upload style="display: none;" 
      ref="upload" 
      :formData="formData" 
      :item="item" 
      :vectorId="vectorId" 
      @input="input" />
  </div>
</template>
<script>
import vueSignature from "vue-signature";

import FTSFileUpload from "./FTSFileUpload";
import FTSDisplay from "./FTSDisplay";

import moment from "moment";

export default {
  components: {
    'fts-file-upload': FTSFileUpload,
    'fts-display': FTSDisplay,
    vueSignature
  },
  props: {
    formData: Object,
    item: Object,
    vectorId: [ Number, String ]
  },
  data() {
    return {
      uid: null,
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)"
      },
      disabled: false,
      dataUrl: "",
      signed: false,
    };
  },
  methods: {
    save() {
      var _this = this;
      if (_this.$refs.signature.isEmpty()) {
        this.input();
      } else {
        _this.$refs.signature.addWaterMark({
          text: moment(new Date()).format('DD/MM/YYYY hh:mm'), // watermark text, > default ''
          font: "16px Arial", // mark font, > default '20px sans-serif'
          style: "fill", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
          fillStyle: "lightgray", // fillcolor, > default '#333'
          strokeStyle: "lightgray", // strokecolor, > default '#333'
          x: 90, // fill positionX, > default 20
          y: 80, // fill positionY, > default 20
          sx: 40, // stroke positionX, > default 40
          sy: 40 // stroke positionY, > default 40
        });

        _this.disabled = true;
        // var png = _this.$refs.signature.save();
        var jpeg = _this.$refs.signature.save("image/jpeg");
        // var svg = _this.$refs.signature.save("image/svg+xml");
        // console.log(png);
        _this.$refs.upload.uploadDataUrl(jpeg);

        console.log(jpeg);

        _this.signed = true;
        // console.log(svg);
      }
    },
    clear() {
      var _this = this;
      if(!_this.isSigned) {
        _this.$refs.signature.clear();
      }

      _this.disabled = false;
      _this.signed = false;
      _this.formData[_this.item.fieldName] = null;
      _this.input();
    },
    undo() {
      var _this = this;
      _this.signed = false;
      _this.$refs.signature.undo();
    },
    addWaterMark() {
      var _this = this;
      _this.$refs.signature.addWaterMark({
        text: moment(new Date()).format('DD/MM/YYYY hh:mm'), // watermark text, > default ''
        font: "16px Arial", // mark font, > default '20px sans-serif'
        style: "fill", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
        fillStyle: "lightgray", // fillcolor, > default '#333'
        strokeStyle: "lightgray", // strokecolor, > default '#333'
        x: 50, // fill positionX, > default 20
        y: 100, // fill positionY, > default 20
        sx: 50, // stroke positionX, > default 40
        sy: 100 // stroke positionY, > default 40
      });
    },
    fromDataURL(url) {
      var _this = this;
      _this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
    },
    handleDisabled() {
      var _this = this;
      _this.disabled = !_this.disabled;
    },
    input(val) {
      this.$emit("input", val);
    },
  },
  computed: {
    isSigned() {
      let data = this.formData[this.item.fieldName]
      if(data && data.path) {
        this.signed = true
        return true
      } else {
        this.signed = false
        return false
      }
    }
  },
  mounted() {
    this.uid = this._uid
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-signature {
  .signature-wrapper {
    border: 1px solid var(--fts-form-control-border);
  }
  .signature-action {
    display: flex;
    justify-content: flex-end;
    width: 300px;
    padding: 4px;
    font-size: .75rem;
    background: var(--fts-gray-1);
    .signature-action-btn {
      padding: .375rem .75rem;
      display: flex;
      align-items: center;
      margin: 2px;
      background: var(--fts-background);
      color: var(--fts-gray-5);
      font-size: .75rem;
      line-height: 1.5;
      cursor: pointer;
      &.primary-btn {
        color: $primaryColor;
      }
      &.danger-btn {  
        color: var(--fts-danger);
      }    
      svg {
        margin-right: .375rem;
      }
      .action-btn-label {
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: .0892857143em;
      }
    }
  }
}
</style>
